import React, { Fragment, useRef } from 'react';
import './index.scss';
import { If } from 'common/src/components';
export interface IUploadParamItem {
    name: string;
    value: string;
}
interface IProps {
    id?: string;
    name?: string;
    children: string | JSX.Element;
    accept?: string;
    paramList?: IUploadParamItem[];
    onChooseFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const UploadFile = (props: IProps) => {
    const { paramList = [], name = 'fileImg', onChooseFile, accept = '', id = 'upload-form' } = props;
    const inputRef = useRef<HTMLInputElement>(null);
    const uploadFile = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };
    return (
        <form method="POST" target="test" encType="multipart/form-data" id={id}>
            <input
                type="file"
                name={name}
                title=""
                ref={inputRef}
                accept={accept}
                style={{ display: 'none' }}
                onChange={onChooseFile}
            />
            <div onClick={uploadFile}>{props.children}</div>
            <If condition={paramList.length > 0}>
                <Fragment>
                    {paramList.map((item, index) => {
                        return (
                            <input key={index} name={item.name} defaultValue={item.value} style={{ display: 'none' }} />
                        );
                    })}
                </Fragment>
            </If>
        </form>
    );
};
